import { ClassroomAffiliate, School } from "lib/api/affiliates";
import {
  AFFILIATE_SEARCH_SCHOOL,
  AFFILIATE_SEARCH_TEACHER,
} from "utils/hooks/useAffiliateSearch";

export type AffiliateType =
  | typeof AFFILIATE_SEARCH_SCHOOL
  | typeof AFFILIATE_SEARCH_TEACHER;

export type SchoolWithAffiliateUid = School & {
  defaultEducatorClassroomAffiliateCode: string;
};

export type Affiliate = ClassroomAffiliate | School | SchoolWithAffiliateUid;

// type guards for distinction between types specifically implemented for transient state of Affiliates

export function isSchool(
  school: School | ClassroomAffiliate
): school is School {
  return "id" in school;
}

export function isSchoolWithAffiliateId(
  school: School | SchoolWithAffiliateUid
): school is SchoolWithAffiliateUid {
  return "defaultEducatorClassroomAffiliateCode" in school;
}

export function isClassroomAffiliate(
  affiliate: ClassroomAffiliate | School
): affiliate is ClassroomAffiliate {
  return "classroom" in affiliate;
}
